import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { IRequirementMast } from "../../models/RequirementMast";
import { Table } from "./Table";

export interface IModel {
    open: boolean,
    singleData: IRequirementMast
}

export const SpecialConstraintApprove = (permissions: { tab: number, is_Create?: boolean, is_Delete?: boolean, is_Update?: boolean, is_Export?: boolean, is_View?: boolean }) => {
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);
    const [spinner, setSpinner] = useState(false);

    return (
        <>
            {spinner && <ProgressSpinner className="m-auto left-50 mt-8" />}
            <Table setSpinner={setSpinner} permissions={permissions} toast={toast} reload={reload} spinner={spinner} setReload={setReload} />
            <Toast ref={toast} />
        </>
    );
}
